import { ReactNode } from 'react';

import { useNavigate } from 'react-router-dom';

import { Auth0Provider } from '@auth0/auth0-react';

interface AuthProviderProps {
  children: ReactNode;
}

const AuthProvider = ({ children }: AuthProviderProps) => {
  const navigate = useNavigate();

  let domain = import.meta.env.VITE_AUTH0_DOMAIN;
  let clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
  let audience = import.meta.env.VITE_AUTH0_AUDIENCE;
  let redirect_uri = import.meta.env.VITE_AUTH0_REDIRECT_URI;

  const authProvider =
    document.cookie.indexOf('authProvider=mi') !== -1 ? 'mi' : 'cp';
  if (authProvider === 'mi') {
    domain = import.meta.env.VITE_MI_AUTH0_DOMAIN;
    clientId = import.meta.env.VITE_MI_AUTH0_CLIENT_ID;
    audience = import.meta.env.VITE_MI_AUTH0_AUDIENCE;
    redirect_uri = import.meta.env.VITE_MI_AUTH0_REDIRECT_URI;
  }

  console.log(
    `Initializing Auth0Provider with ${domain} ${clientId} ${audience}`,
  );
  if (!(domain && clientId && redirect_uri)) {
    console.error('Something went wrong loading the app');
    return null;
  }

  const onRedirectCallback = (appState: { returnTo?: string } | undefined) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience,
        redirect_uri,
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      // The Studio OAuth flow also relies on `code` and `state` query parameters in the URL.
      // However, Auth0’s default behavior is to automatically process and remove these values
      // after a redirect, which causes conflicts and invalidates the session.
      // This is to prevent that from happening.
      skipRedirectCallback={window.location.pathname === '/studio/callback'}
    >
      {children}
    </Auth0Provider>
  );
};

export default AuthProvider;
